"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CartStore = require("../../stores/CartStore.jsx");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _OrderScheduleScreen = require("./OrderScheduleScreen.jsx");

var _OrderScheduleScreen2 = _interopRequireDefault(_OrderScheduleScreen);

var _ScheduleScreenStore = require("../../stores/ScheduleScreenStore.jsx");

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _TabContainer = require("../generic/TabContainer.js");

var _TabContainer2 = _interopRequireDefault(_TabContainer);

var _TabPane = require("../generic/TabPane.js");

var _TabPane2 = _interopRequireDefault(_TabPane);

var _parse = require("parse");

var _parse2 = _interopRequireDefault(_parse);

var _DeliveryAddressSelect = require("./DeliveryAddressSelect.jsx");

var _DeliveryAddressSelect2 = _interopRequireDefault(_DeliveryAddressSelect);

var _PickupAddressView = require("./PickupAddressView.jsx");

var _PickupAddressView2 = _interopRequireDefault(_PickupAddressView);

var _DineInAddressView = require("./DineInAddressView.jsx");

var _DineInAddressView2 = _interopRequireDefault(_DineInAddressView);

var _Address = require("./Address.jsx");

var _Address2 = _interopRequireDefault(_Address);

var _MainStore = require("../../stores/MainStore.jsx");

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility = require("../../utils/Utility.jsx");

var Utils = _interopRequireWildcard(_Utility);

var Utility = _interopRequireWildcard(_Utility);

var _LoginBtn = require("../cart-view/cart-left/LoginBtn.jsx");

var _LoginBtn2 = _interopRequireDefault(_LoginBtn);

var _Actions = require("../../Actions.jsx");

var _Actions2 = _interopRequireDefault(_Actions);

var _Constants = require("../Constants.jsx");

var Constants = _interopRequireWildcard(_Constants);

var _Spinner = require("../generic/Spinner.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _SpinButton = require("../generic/SpinButton.jsx");

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PICKUP_NOT_AVAILABLE_MSG = "We are not providing Pickup for this location. Please choose Delivery option.";
var DELIVERY_NOT_AVAILABLE_MSG = "We are not providing Delivery for this location. Please choose Pick Up option.";
var SIGN_IN_TITLE = "Please Sign In";

var PICKUP = Constants.PICKUP;
var CURBSIDEPICKUP = Constants.CURBSIDEPICKUP;
var DINEIN = Constants.DINEIN;
var DELIVERY = Constants.DELIVERY;
var MAX_ADDRESS_LENGTH = 100;

var ScheduleScreenModal = function (_React$Component) {
    _inherits(ScheduleScreenModal, _React$Component);

    function ScheduleScreenModal(props) {
        _classCallCheck(this, ScheduleScreenModal);

        var _this = _possibleConstructorReturn(this, (ScheduleScreenModal.__proto__ || Object.getPrototypeOf(ScheduleScreenModal)).call(this, props));

        _this.state = {
            orderType: Constants.PICKUP,
            errors: "",
            isSavedAddressActive: true,
            scheduledDate: _ScheduleScreenStore2.default.getScheduledDate(),
            vColor: "",
            vMakeModel: "",
            slData: "",
            curbSideObj: {},
            idx: "",
            deliveryAddressObj: {},
            addNewAddressObj: {},
            isPreferCurbside: false,
            isPickUpLocationSelected: false,
            startOrder: false,
            disableStartOrderButton: false
        };

        _this._bind('validateOrder', 'clickedOnDeliveryTab', 'clickedOnPickupTab', 'clickedOnDineInTab', 'handleChange', 'onClickSavedAddress', 'onClickAddNewAddress', 'afterValidateSuccess', 'scheduleShowModal',
        // 'setErrorNodeActiveFalse',
        'handleAddressChange', 'handleDeliveryAddressSelect', 'handleSlLocationData', 'handleCurbSideChange', 'validateDeliveryOrderType', 'validatePickUpOrderType', 'validateDineInOrderType', 'validateExistingUser', 'validateGuestUser', 'scrollToTop', 'updateScheduledDate', 'loadTabContainer');
        return _this;
    }

    _createClass(ScheduleScreenModal, [{
        key: "_bind",
        value: function _bind() {
            var _this2 = this;

            for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
                methods[_key] = arguments[_key];
            }

            methods.forEach(function (method) {
                return _this2[method] = _this2[method].bind(_this2);
            });
        }
    }, {
        key: "UNSAFE_componentWillMount",
        value: function UNSAFE_componentWillMount() {

            var currentUser = _parse2.default.User.current();

            var isSavedAddressActive = true;
            if (!Utils.isEmptyObj(currentUser)) {
                isSavedAddressActive = _ScheduleScreenStore2.default.getSavedAddressActive();
            } else {
                isSavedAddressActive = false;
            }

            var defaultOrderType = _CartStore2.default.getOrderType();

            var deliveryAddress = _CartStore2.default.getDeliveryAddress();
            var deliveryAddressObj = {};
            var addNewAddressObj = {};

            if (!Utils.isEmptyObj(deliveryAddress)) {

                if (isSavedAddressActive == true) {
                    deliveryAddressObj = deliveryAddress;
                } else {
                    addNewAddressObj = deliveryAddress;
                }
            }

            this.setState({
                orderType: defaultOrderType,
                vMakeModel: _CartStore2.default.getOrderVehicleMakeModel(),
                vColor: _CartStore2.default.getOrderVehicleColor(),
                isPreferCurbside: _CartStore2.default.getIsPreferCurbsideEnabled(),
                slData: _CartStore2.default.getDineInServiceLocationData(),
                isSavedAddressActive: isSavedAddressActive,
                deliveryAddressObj: deliveryAddressObj,
                errors: ""
                // addNewAddressObj: addNewAddressObj
            });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this3 = this;

            //bootstrap modal show on comp mount.
            $('#scheduleOrderModal').modal('show');
            $("#scheduleOrderModal").on('hidden.bs.modal', function () {
                _this3.props.callBackParent(false);
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //hide modal if open while unmounting
            if ($('#scheduleOrderModal').hasClass('show')) {
                // The modal is open, so you can hide it
                $('#scheduleOrderModal').modal('hide');
            }
        }

        // UNSAFE_componentWillReceiveProps(nextProps) {
        //     if(nextProps.show){
        //         Utils.showSpinner();
        //     }
        // }

    }, {
        key: "handleChange",
        value: function handleChange(event) {
            var _setState;

            this.setState((_setState = {}, _defineProperty(_setState, event.target.name, event.target.value), _defineProperty(_setState, "error", ''), _setState));
        }
    }, {
        key: "clickedOnDeliveryTab",
        value: function clickedOnDeliveryTab() {

            // check if deliveryInfo exist or not
            // check if deliveryConfig exist or not
            // if not exist the delivery Then return the null value
            var locationDeliveryConfig = _CartStore2.default.getDeliveryConfigInfo();
            if (locationDeliveryConfig == null || Utils.isEmptyObj(locationDeliveryConfig)) {
                this.setState({
                    disableStartOrderButton: true
                });

                //hide schedule Modal befoe
                //opening schedule modal
                this.handleScheduleModal();

                _sweetalert2.default.fire({
                    title: 'Delivery Not Available',
                    text: DELIVERY_NOT_AVAILABLE_MSG,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                }).then(function (result) {
                    if (result.isDismissed) {
                        var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                        if (scheduleOrderModal) {
                            scheduleOrderModal.style.display = "block";
                        }
                    }
                });
            } else {
                this.setState({
                    orderType: Constants.DELIVERY,
                    // scheduledDate : null,
                    scheduledDate: _ScheduleScreenStore2.default.getScheduledDate(),
                    errors: "",
                    disableStartOrderButton: false

                });
            }
        }
    }, {
        key: "clickedOnPickupTab",
        value: function clickedOnPickupTab() {
            var isPickupDisable = _MainStore2.default.isPickUpOrderDisabled();
            if (isPickupDisable) {
                //hide schedule Modal befoe
                //opening schedule modal
                this.handleScheduleModal();

                this.setState({
                    disableStartOrderButton: true
                });

                _sweetalert2.default.fire({
                    title: 'Pick Up Not Available',
                    text: PICKUP_NOT_AVAILABLE_MSG,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                }).then(function (result) {
                    if (result.isDismissed) {
                        var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                        if (scheduleOrderModal) {
                            scheduleOrderModal.style.display = "block";
                        }
                    }
                });
            } else {
                this.setState({
                    orderType: Constants.PICKUP,
                    scheduledDate: _ScheduleScreenStore2.default.getScheduledDate(),
                    errors: "",
                    disableStartOrderButton: false
                });
            }
        }
    }, {
        key: "clickedOnDineInTab",
        value: function clickedOnDineInTab() {
            this.setState({
                orderType: Constants.DINEIN,
                scheduledDate: null,
                errors: "",
                disableStartOrderButton: false
            });
        }
    }, {
        key: "onClickSavedAddress",
        value: function onClickSavedAddress() {
            this.setState({
                isSavedAddressActive: true,
                errors: ""
            });
        }
    }, {
        key: "onClickAddNewAddress",
        value: function onClickAddNewAddress() {
            this.setState({
                isSavedAddressActive: false,
                errors: ""
            });
        }
    }, {
        key: "setOrderTabContainer",
        value: function setOrderTabContainer() {
            if (this.isDineIn()) {
                return 2;
            } else if (this.isDelivery()) {
                return 1;
            } else {
                //Delivery for default select
                return 0;
            }
        }
    }, {
        key: "isDelivery",
        value: function isDelivery() {
            return this.state.orderType == DELIVERY;
        }
    }, {
        key: "isPickup",
        value: function isPickup() {
            return this.state.orderType == PICKUP;
        }
    }, {
        key: "isDineIn",
        value: function isDineIn() {
            return this.state.orderType == DINEIN;
        }
    }, {
        key: "setASAPandScheduleComponent",
        value: function setASAPandScheduleComponent() {

            var component = null;
            // if (!this.isDineIn()) {
            if (!(this.state.orderType == DINEIN)) {
                component = _react2.default.createElement(
                    "div",
                    { className: "container", style: { maxWidth: '100%' } },
                    this.getScheduledDateStructure()
                );
            }
            return component;
        }
    }, {
        key: "updateScheduledDate",
        value: function updateScheduledDate(newDate) {
            if (newDate) {
                this.setState({
                    scheduledDate: newDate
                    // isErrorNodeActive : false
                });
            } else {
                this.setState({
                    scheduledDate: null
                    // isErrorNodeActive : false
                });
            }
        }
    }, {
        key: "getScheduledDateStructure",
        value: function getScheduledDateStructure() {

            var orderType = this.state.orderType;
            var component = _react2.default.createElement(_OrderScheduleScreen2.default, {
                orderType: orderType,
                locationDetail: _CartStore2.default.getLocationDetail(),
                updateScheduledDate: this.updateScheduledDate
                // placeAsapOrder={this.placeAsapOrder}
                // value12={this.state.value12}
                , scheduledDate: this.state.scheduledDate
                // scheduleOrder={this.scheduleOrder}
                // getOrderSchedulerRef={this.getOrderSchedulerRef}
            });

            return component;
        }
    }, {
        key: "scrollToTop",
        value: function scrollToTop(e) {

            $(".schedule__modal_body").animate({ scrollTop: 0 }, 'slow');
            // window.scrollTo(0, 0);
        }

        // validate existing or guest users details

    }, {
        key: "validateDeliveryOrderType",
        value: function validateDeliveryOrderType() {
            var self = this;
            var currentUser = _parse2.default.User.current();
            var formIsValid = true;

            if (!Utils.isEmpty(currentUser)) {
                formIsValid = self.validateExistingUser();
            } else {
                formIsValid = self.validateGuestUser();
            }

            return formIsValid;
        }

        //validate and save existing user delivery address info

    }, {
        key: "validateExistingUser",
        value: function validateExistingUser() {
            var _this4 = this;

            var currentUser = _parse2.default.User.current();
            var router = this.props.history;
            var locId = null;

            var setErrorsAndReturn = function setErrorsAndReturn(errors) {
                _this4.setState({ errors: errors }, function () {
                    Constants.scrollToTop("error-container");
                });
                return false;
            };

            // Check validation for the existing saved delivery address
            if (this.state.isSavedAddressActive) {
                if (Utils.isEmptyObj(this.state.deliveryAddressObj) || this.state.deliveryAddressObj === null) {
                    return setErrorsAndReturn("Required: Choose Delivery Address");
                }
            } else {
                // Check validation for new address
                if (!Utils.isEmptyObj(this.state.addNewAddressObj)) {
                    var _state$addNewAddressO = this.state.addNewAddressObj,
                        name = _state$addNewAddressO.name,
                        addLine1 = _state$addNewAddressO.addLine1,
                        addLine2 = _state$addNewAddressO.addLine2,
                        phoneNumber = _state$addNewAddressO.phoneNumber;

                    // Mutate the name property by trimming its value

                    this.state.addNewAddressObj.name = !Utils.isEmpty(name) ? name.trim() : name;

                    // Validation check for user name
                    if (Utils.isEmpty(name)) {
                        return setErrorsAndReturn("User name is empty.");
                    } else {
                        // Adjust the regex according to your specific criteria
                        var regex = /^[a-zA-Z0-9\s]*$/;

                        if (!regex.test(name)) {
                            return setErrorsAndReturn("Invalid characters in the user name.");
                        }
                    }

                    // Validation checks for phone number
                    if (Utils.isEmpty(phoneNumber)) {
                        return setErrorsAndReturn("Phone number cannot be empty.");
                    } else {
                        // Remove non-numeric characters from the phone number
                        var sanitizedPhoneNumber = Utils.removeNonNumber(phoneNumber);

                        if (sanitizedPhoneNumber.length !== 10) {
                            return setErrorsAndReturn("Phone number must be exactly 10 digits.");
                        }
                    }

                    // Validation checks for address line 1
                    if (Utils.isEmpty(addLine1)) {
                        return setErrorsAndReturn("Delivery address is empty.");
                    } else if (addLine2.length >= MAX_ADDRESS_LENGTH) {
                        return setErrorsAndReturn("Apartment, unit, suite, or floor address should be less than 100 characters.");
                    }

                    // Update the address object with the sanitized phone number
                    this.state.addNewAddressObj.phoneNumber = sanitizedPhoneNumber;

                    //remove whiteSpace
                    this.state.addNewAddressObj.name = !Utils.isEmpty(name) ? name.replaceAll(/\s+/g, ' ') : name;

                    currentUser.addUnique("deliveryAddress", this.state.addNewAddressObj);
                    currentUser.save().then(function (user) {
                        // Update user
                    }, function (error) {
                        Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                        _this4.setState({ errors: error.message });
                    });

                    // Return true if validation passes and save is successful
                    return true;
                } else {
                    return setErrorsAndReturn("Enter the delivery address:");
                }
            }

            return true;
        }

        //Validate guest user details

    }, {
        key: "validateGuestUser",
        value: function validateGuestUser() {
            var _this5 = this;

            var setErrorsAndReturn = function setErrorsAndReturn(errors) {
                _this5.setState({ errors: errors }, function () {
                    Constants.scrollToTop("error-container");
                });
                return false;
            };

            // Check if the new address object is not empty
            if (!Utils.isEmptyObj(this.state.addNewAddressObj)) {
                var _state$addNewAddressO2 = this.state.addNewAddressObj,
                    name = _state$addNewAddressO2.name,
                    addLine1 = _state$addNewAddressO2.addLine1,
                    addLine2 = _state$addNewAddressO2.addLine2,
                    phoneNumber = _state$addNewAddressO2.phoneNumber;

                // Validation check for user name

                if (Utils.isEmpty(name)) {
                    return setErrorsAndReturn("User name is empty.");
                } else {
                    // Adjust the regex according to your specific criteria
                    var regex = /^[a-zA-Z0-9\s]*$/;

                    if (!regex.test(name)) {
                        return setErrorsAndReturn("Invalid characters in the user name.");
                    }
                }

                // Validation checks for phone number
                if (Utils.isEmpty(phoneNumber)) {
                    return setErrorsAndReturn("Phone number is empty.");
                } else {
                    var sanitizedPhoneNumber = Utils.removeNonNumber(phoneNumber);
                    // Validation check for phone number length
                    if (sanitizedPhoneNumber.length !== 10) {
                        return setErrorsAndReturn("Phone number must be of 10 digits.");
                    }
                }

                // Validation checks for address
                if (Utils.isEmpty(addLine1)) {
                    return setErrorsAndReturn("Delivery address is empty.");
                } else if (addLine2.length >= MAX_ADDRESS_LENGTH) {
                    return setErrorsAndReturn("Apartment, unit, suite, or floor address should be less than 100 characters.");
                }

                // Update the address object with the sanitized phone number
                this.state.addNewAddressObj.phoneNumber = sanitizedPhoneNumber;

                //remove whiteSpace
                this.state.addNewAddressObj.name = !Utils.isEmpty(name) ? name.replaceAll(/\s+/g, ' ') : name;

                // Return true if all validations pass
                return true;
            } else {
                // Return false if the new address object is empty
                return setErrorsAndReturn("Enter the delivery address:");
            }
        }
    }, {
        key: "validatePickUpOrderType",
        value: function validatePickUpOrderType() {
            var self = this;
            var errors = "";
            var formIsValid = true;

            var isCurbsidePickup = this.state.isPreferCurbside;
            var isLocationCurbsidePickupEnabled = _CartStore2.default.isLocationCurbsidePickupEnabled();

            //for curbside pickup validation
            if (isCurbsidePickup == true) {
                var vColor = this.state.vColor;
                var vMakeModel = this.state.vMakeModel;

                if (Utils.isEmpty(vColor.trim())) {
                    formIsValid = false;
                    errors = "Required: Vehicle Color";
                    self.scrollToTop();

                    this.setState({ errors: errors }, function () {
                        Constants.scrollToTop("error-container");
                    });
                    return formIsValid;
                }

                if (Utils.isEmpty(vMakeModel.trim())) {
                    formIsValid = false;
                    errors = "Required: Vehicle Make & Model";
                    self.scrollToTop();

                    this.setState({ errors: errors }, function () {
                        Constants.scrollToTop("error-container");
                    });
                    return formIsValid;
                }
            }

            this.setState({ errors: errors });
            return formIsValid;
        }
    }, {
        key: "validateDineInOrderType",
        value: function validateDineInOrderType() {
            var self = this;
            var errors = "";
            var formIsValid = true;

            var serviceLocationData = this.state.slData;
            var isDineInEnabled = _MainStore2.default.isDineInEnabled();

            if (isDineInEnabled) {

                var restaurantIsOpen = Constants.checkRestaurantIsOpen();

                if (restaurantIsOpen == false) {
                    formIsValid = false;
                    errors = "This location is closed right now.";
                    self.scrollToTop();
                }

                if (Utils.isEmpty(serviceLocationData)) {
                    var sl = _CartStore2.default.getDineInServiceLocation();
                    formIsValid = false;
                    errors = sl;
                    self.scrollToTop();
                }
            } else {
                formIsValid = false;
                errors = "Dine-In ordering is disabled.";
                self.scrollToTop();
            }

            this.setState({ errors: errors }, function () {
                Constants.scrollToTop("error-container");
            });
            return formIsValid;
        }
    }, {
        key: "validateOrder",
        value: function validateOrder() {
            var self = this;

            //validate for pickUp order Type
            if (this.isPickup()) {
                if (self.validatePickUpOrderType()) {

                    //showSpinner();
                    Utils.showSpinner();

                    var isCurbsidePickup = this.state.isPreferCurbside;

                    var currentUser = _parse2.default.User.current();
                    var isSavedAddressActive = false;

                    if (!Utils.isEmptyObj(currentUser)) {
                        isSavedAddressActive = true;
                    } else {
                        isSavedAddressActive = false;
                    }

                    if (isCurbsidePickup == true) {

                        // curbside Pickup
                        var scheduleObj = {
                            orderType: this.state.orderType,
                            isPreferCurbside: this.state.isPreferCurbside,
                            isPickUpLocationSelected: false,
                            vColor: this.state.vColor,
                            vMakeModel: this.state.vMakeModel,
                            scheduledDate: this.state.scheduledDate,
                            isSavedAddressActive: isSavedAddressActive,
                            // Delivery Data
                            deliveryAddressObj: {},
                            idx: "",
                            // Dine In Data
                            sldata: "",
                            startOrder: true
                        };

                        this.afterValidateSuccess(scheduleObj);
                    } else {
                        // Pickup
                        var _scheduleObj = {
                            orderType: this.state.orderType,
                            scheduledDate: this.state.scheduledDate,
                            isSavedAddressActive: isSavedAddressActive,
                            // Curbside Pickup Data
                            isPreferCurbside: false,
                            isPickUpLocationSelected: this.state.isPickUpLocationSelected,
                            vColor: "",
                            vMakeModel: "",
                            // Delivery Data
                            deliveryAddressObj: {},
                            idx: "",
                            // Dine In Data
                            sldata: "",
                            startOrder: true
                        };

                        this.afterValidateSuccess(_scheduleObj);
                    }
                }
            }

            //validate for delivery order Type
            if (this.isDelivery()) {

                if (self.validateDeliveryOrderType()) {

                    //showSpinner();
                    Utils.showSpinner();

                    var deliveryAddressObj = {};
                    if (this.state.isSavedAddressActive) {
                        deliveryAddressObj = this.state.deliveryAddressObj;
                    } else {

                        Utils.getDeliveryAddressSearchStr();
                        deliveryAddressObj = this.state.addNewAddressObj;
                    }

                    var _scheduleObj2 = {
                        orderType: this.state.orderType,
                        deliveryAddressObj: deliveryAddressObj,
                        idx: this.state.idx,
                        isSavedAddressActive: this.state.isSavedAddressActive,
                        // existing
                        scheduledDate: this.state.scheduledDate,
                        // Curbside Pickup Data
                        isPreferCurbside: false,
                        isPickUpLocationSelected: false,
                        vColor: "",
                        vMakeModel: "",
                        startOrder: true

                    };

                    this.afterValidateSuccess(_scheduleObj2);
                }
            }

            //validate for DineIn orderType
            if (this.isDineIn()) {
                // console.log(self.validateDineInOrderType());
                if (self.validateDineInOrderType()) {
                    //showSpinner();
                    Utils.showSpinner();

                    var _currentUser = _parse2.default.User.current();
                    var _isSavedAddressActive = false;

                    if (!Utils.isEmptyObj(_currentUser)) {
                        _isSavedAddressActive = true;
                    } else {
                        _isSavedAddressActive = false;
                    }

                    var _scheduleObj3 = {
                        orderType: this.state.orderType,
                        sldata: this.state.slData,
                        scheduledDate: null,
                        // Delivery Data
                        isSavedAddressActive: _isSavedAddressActive,
                        deliveryAddressObj: {},
                        idx: "",
                        // Curbside Pickup Data
                        isPreferCurbside: false,
                        isPickUpLocationSelected: false,
                        vColor: "",
                        vMakeModel: "",
                        startOrder: true
                    };

                    this.afterValidateSuccess(_scheduleObj3);
                }
            }
        }
    }, {
        key: "afterValidateSuccess",
        value: function afterValidateSuccess(scheduleObj) {
            var _this6 = this;

            setTimeout(function () {
                //hide bootstrap modal
                $('#scheduleOrderModal').modal('hide');
                _this6.props.callBackParent(false);
                Utils.hideSpinner();
            }, 100);

            // Update the store
            _ScheduleScreenStore2.default.updateScheduleScreenData(scheduleObj);

            //reset temp OrderType;
            // ScheduleScreenStore.setTempOrderType(null);

            // this.resetAllLocalState();

            // Hide/Show the schedule screen modal
            // this.props.callBackParent(false);
        }

        //hide scheduleModal
        //when sweet alert is open

    }, {
        key: "handleScheduleModal",
        value: function handleScheduleModal() {

            var scheduleOrderModal = document.getElementById("scheduleOrderModal");
            if (scheduleOrderModal) {
                scheduleOrderModal.style.display = "none";
                // this.props.callBackParent(status);
            }
        }
    }, {
        key: "scheduleShowModal",
        value: function scheduleShowModal() {
            return this.props.show;
        }
    }, {
        key: "handleDeliveryAddressSelect",
        value: function handleDeliveryAddressSelect(addressObj, idx) {

            if (!Utils.isEmptyObj(addressObj)) {
                this.setState({
                    // isErrorNodeActive        : false,
                    deliveryAddressObj: addressObj,
                    idx: idx,
                    errors: ""

                });
            } else {
                this.setState({
                    // isErrorNodeActive: false,
                    deliveryAddressObj: {},
                    idx: ""
                });
            }
        }
    }, {
        key: "handleSlLocationData",
        value: function handleSlLocationData(slData) {
            this.setState({
                // isErrorNodeActive        : false,
                slData: slData,
                errors: ""
            });
        }
    }, {
        key: "handleCurbSideChange",
        value: function handleCurbSideChange(obj) {

            this.setState({
                // isErrorNodeActive: false,
                vColor: obj.vColor,
                vMakeModel: obj.vMakeModel,
                isPreferCurbside: obj.isPreferCurbside,
                isPickUpLocationSelected: obj.isPickUpLocationSelected,
                curbSideObj: obj,
                errors: ""
            });
        }
    }, {
        key: "handleAddressChange",
        value: function handleAddressChange(obj) {

            if (!Utils.isEmptyObj(obj)) {
                this.setState({
                    addNewAddressObj: obj,
                    errors: ""

                });
            } else {
                this.setState({
                    addNewAddressObj: {},
                    errors: ""

                });
            }
        }

        // setErrorNodeActiveFalse(){
        //     this.setState({
        //         isErrorNodeActive        : false,
        //         stillRequiredValidations : [],
        //         cartErrorMessage: null
        //     });
        // }

    }, {
        key: "showAddressAddStructure",
        value: function showAddressAddStructure() {
            var showAddressAddModal = false;
            var showLoginModal = false;

            // if (!Parse.User.current()) {
            //     // showLoginModal = true;
            //     showLoginModal = true;
            // } else {
            //     showAddressAddModal = true;
            // }

            this.setState({
                loginTitle: SIGN_IN_TITLE,
                view: {
                    showLoginModal: showLoginModal,
                    showCartModal: false,
                    showItemOptionModal: false,
                    showAddressAddModal: showAddressAddModal,
                    showCardAddModal: false,
                    showUserProfileModal: false,
                    showOrderSuccessModal: false,
                    showCustomOrderPlacedModal: false
                }
            });
        }
    }, {
        key: "loadViewIfRestaurantClosed",
        value: function loadViewIfRestaurantClosed() {

            var restaurantIsOpen = Constants.checkRestaurantIsOpen();
            var scheduledDate = _ScheduleScreenStore2.default.getScheduledDate();

            if (restaurantIsOpen == false && Utils.isEmpty(scheduledDate) && !this.isDineIn()) {
                return _react2.default.createElement(
                    "div",
                    { className: "alert alert-info ft-14", role: "alert" },
                    _react2.default.createElement(
                        "i",
                        { className: "mr-1 ft-20 location-card-ico card-text mb-1 material-icons mt-1" },
                        "info "
                    ),
                    _react2.default.createElement(
                        "span",
                        { className: "sr-only" },
                        "Error:"
                    ),
                    _react2.default.createElement(
                        "b",
                        { className: "err-box location-card-title card-text px-1 mb-1" },
                        "This location is closed. But you can schedule ahead."
                    )
                );
            }
        }
    }, {
        key: "loadViewIfDeliveryHoursNotAvailable",
        value: function loadViewIfDeliveryHoursNotAvailable() {

            var scheduledDate = _ScheduleScreenStore2.default.getScheduledDate();

            var dateStringWithTime = Utils.formatTime(new Date(scheduledDate));

            if (scheduledDate) {
                var orderTypeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours(this.state.orderType);
                var isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, scheduledDate);

                if (isLocationOrderTypeOpen != true && this.isDelivery()) {
                    return _react2.default.createElement(
                        "div",
                        { className: "alert alert-danger ft-14", role: "alert" },
                        _react2.default.createElement(
                            "i",
                            { className: "mr-5 material-icons" },
                            "info "
                        ),
                        _react2.default.createElement(
                            "span",
                            { className: "sr-only" },
                            "Error:"
                        ),
                        _react2.default.createElement(
                            "b",
                            null,
                            "Delivery is not available on ",
                            dateStringWithTime
                        )
                    );
                }
            }
        }

        //show close/hide close modal btn

    }, {
        key: "handleCloseBtn",
        value: function handleCloseBtn() {
            var restaurantIsOpen = Constants.checkRestaurantIsOpen();
            return restaurantIsOpen;
        }
    }, {
        key: "loadTabContainer",
        value: function loadTabContainer() {
            var component = null;

            if (_MainStore2.default.isLocationForDineInOnly()) {
                component = _react2.default.createElement(
                    "div",
                    { id: "dinein-only mt-3" },
                    _react2.default.createElement(
                        "div",
                        {
                            className: !Utils.isEmpty(this.state.errors) ? "form-group dinein-sl" : "form-group dinein-struct"
                        },
                        _react2.default.createElement(_DineInAddressView2.default, {
                            handleSlLocationData: this.handleSlLocationData,
                            slData: this.state.slData,
                            callBackParent: this.handleScheduleModal
                        })
                    )
                );
            } else {
                component = _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        _TabContainer2.default,
                        {
                            classNames: "tab",
                            tabLinksClassNames: "btn custom-btn-outline-primary ft-14",
                            selected: this.setOrderTabContainer(),
                            activePropsState: false
                        },
                        _react2.default.createElement(
                            _TabPane2.default,
                            {
                                label: "PICK UP",
                                classNames: "",
                                onTabClick: this.clickedOnPickupTab,
                                selected: this.setOrderTabContainer()
                                // isHiddenDiv={MainStore.isPickUpOrderDisabled()}
                                , isHiddenDiv: false
                            },
                            this.renderPickUpComponent()
                        ),
                        _react2.default.createElement(
                            _TabPane2.default,
                            {
                                label: "DELIVERY",
                                classNames: "",
                                onTabClick: this.clickedOnDeliveryTab,
                                selected: this.setOrderTabContainer(),
                                isHiddenDiv: false
                            },
                            this.renderDeliveryComponent()
                        ),
                        _react2.default.createElement(
                            _TabPane2.default,
                            {
                                label: "DINE IN",
                                classNames: "",
                                onTabClick: this.clickedOnDineInTab,
                                selected: this.setOrderTabContainer(),
                                isHiddenDiv: !_MainStore2.default.isDineInEnabled()
                            },
                            _react2.default.createElement(_DineInAddressView2.default, {
                                handleSlLocationData: this.handleSlLocationData,
                                slData: this.state.slData,
                                callBackParent: this.handleScheduleModal
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        this.setASAPandScheduleComponent()
                    )
                );
            }
            return component;
        }
    }, {
        key: "renderPickUpComponent",
        value: function renderPickUpComponent() {

            var isPickupDisable = _MainStore2.default.isPickUpOrderDisabled();
            if (isPickupDisable) {
                return _react2.default.createElement(
                    "div",
                    { className: "panel-default panel-border-less cart-box border-bottom mb-3" },
                    _react2.default.createElement(
                        "h6",
                        { className: "color-red" },
                        PICKUP_NOT_AVAILABLE_MSG
                    )
                );
            } else {
                return _react2.default.createElement(_PickupAddressView2.default, {
                    handleCurbSideChange: this.handleCurbSideChange
                    // callbackParent={this.setErrorNodeActiveFalse}
                    , curbSideObj: this.state.curbSideObj
                });
            }
        }
    }, {
        key: "renderDeliveryComponent",
        value: function renderDeliveryComponent() {
            var currentUser = _parse2.default.User.current();
            var locationDeliveryConfig = _CartStore2.default.getDeliveryConfigInfo();

            if (locationDeliveryConfig == null || Utils.isEmptyObj(locationDeliveryConfig)) {
                return _react2.default.createElement(
                    "div",
                    { className: "panel-default panel-border-less cart-box border-bottom mb-3" },
                    _react2.default.createElement(
                        "h6",
                        { className: "color-red" },
                        DELIVERY_NOT_AVAILABLE_MSG
                    )
                );
            } else if (!Utils.isEmptyObj(currentUser)) {
                return _react2.default.createElement(
                    PaneContent,
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "address-select-container" },
                        _react2.default.createElement(
                            "div",
                            { className: "btn-group btn-group-justified mt-1 w-100" },
                            _react2.default.createElement(
                                "div",
                                { className: "row w-100 ml-1" },
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-lg-6 col-6 no-gutter " },
                                    _react2.default.createElement(_LoginBtn2.default, {
                                        btnText: "Saved Address",
                                        btnclassName: this.state.isSavedAddressActive ? "tablinks credit-tablink credit-tablink-active font-bold ft-16 cart-header" : "cart-header tablinks credit-tablink ft-16",
                                        onClick: this.onClickSavedAddress
                                    })
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { className: "col-lg-6 col-6 no-gutter" },
                                    _react2.default.createElement(_LoginBtn2.default, {
                                        btnText: "Add New Address",
                                        btnclassName: !this.state.isSavedAddressActive ? "tablinks credit-tablink credit-tablink-active font-bold  ft-16 cart-header" : " cart-header tablinks credit-tablink ft-16",
                                        onClick: this.onClickAddNewAddress
                                    })
                                )
                            )
                        )
                    ),
                    this.state.isSavedAddressActive ? _react2.default.createElement(_DeliveryAddressSelect2.default
                    // showAddressAddStructure={this.showAddressAddStructure}
                    // setErrorNodeActiveFalse={this.setErrorNodeActiveFalse}
                    , { handleDeliveryAddressSelect: this.handleDeliveryAddressSelect,
                        history: this.props.history,
                        locId: this.props.locId,
                        callBackParent: this.handleScheduleModal

                        // deliveryAddressObj = {this.state.deliveryAddressObj}
                    }) : _react2.default.createElement(
                        "div",
                        { className: "Order-tab__section mb-20 " },
                        _react2.default.createElement(
                            "p",
                            { className: "font-weight-bold mt-3 lead mb-10 f16-default cart-header" },
                            "Enter the delivery address:"
                        ),
                        _react2.default.createElement(_Address2.default, {
                            addNewAddressObj: this.state.addNewAddressObj,
                            handleAddressChange: this.handleAddressChange,
                            modalId: Constants.SCHEDULE_MODAL_ID,
                            callBackParent: this.handleScheduleModal
                        })
                    )
                );
            } else {
                return _react2.default.createElement(
                    PaneContent,
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "Order-tab__section mb-20" },
                        _react2.default.createElement(
                            "p",
                            { className: "font-weight-bold mt-3 lead mb-10 f16-default cart-header" },
                            "Enter the delivery address:"
                        ),
                        _react2.default.createElement(_Address2.default, {
                            addNewAddressObj: this.state.addNewAddressObj,
                            handleAddressChange: this.handleAddressChange,
                            modalId: Constants.SCHEDULE_MODAL_ID,
                            callBackParent: this.handleScheduleModal
                        })
                    )
                );
            }
        }
    }, {
        key: "checkSelectedOrderTypeIsDisabled",
        value: function checkSelectedOrderTypeIsDisabled() {

            if (this.isDelivery()) {

                var locationDeliveryConfig = _CartStore2.default.getDeliveryConfigInfo();
                if (locationDeliveryConfig == null || Utils.isEmptyObj(locationDeliveryConfig)) {
                    // disable the button
                    return true;
                }
            } else if (this.isPickup()) {

                var isPickupDisable = _MainStore2.default.isPickUpOrderDisabled();
                if (isPickupDisable) {
                    // disable the button
                    return true;
                }
            } else {
                return false;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var disableButton = this.checkSelectedOrderTypeIsDisabled();

            var buttonClass = this.state.disableStartOrderButton ? " disabled" : "";
            // disable the button based on the configuration
            if (disableButton) {
                buttonClass = " disabled";
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_Spinner2.default, null),
                _react2.default.createElement(
                    "div",
                    {
                        className: "modal fade",
                        id: "scheduleOrderModal", tabIndex: "-1", role: "dialog",
                        "aria-labelledby": "modalLabel", "aria-hidden": "true",
                        "data-keyboard": "false", "data-backdrop": "static"
                    },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-dialog modal-dialog-centered modal-md", role: "document" },
                        _react2.default.createElement(
                            "div",
                            { className: "modal-content" },
                            _react2.default.createElement(
                                "div",
                                { className: "modal-header" },
                                _react2.default.createElement(
                                    "h5",
                                    { className: "modal-title text-center", id: "edit-profile" },
                                    "Schedule Order"
                                ),
                                _react2.default.createElement(
                                    "button",
                                    { type: "button", className: "close", "data-dismiss": "modal",
                                        "aria-label": "Close" },
                                    _react2.default.createElement(
                                        "span",
                                        { "aria-hidden": "true" },
                                        "\xD7"
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "modal-body pb-0" },
                                _react2.default.createElement("div", { id: "map_canvas" }),
                                this.loadViewIfRestaurantClosed(),
                                this.loadViewIfDeliveryHoursNotAvailable(),
                                !Utils.isEmpty(this.state.errors) ? _react2.default.createElement(
                                    "div",
                                    { className: "alert alert-danger", role: "alert", id: "error-container" },
                                    _react2.default.createElement(
                                        "i",
                                        { className: "mr-1 ft-20 location-card-ico card-text mb-1 material-icons mt-1" },
                                        "report"
                                    ),
                                    _react2.default.createElement(
                                        "span",
                                        { className: "sr-only" },
                                        "Error:"
                                    ),
                                    _react2.default.createElement(
                                        "b",
                                        { className: "err-box location-card-title card-text px-1 mb-1" },
                                        this.state.errors
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    "div",
                                    { className: "order__tab_btn_group" },
                                    this.loadTabContainer()
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "modal-footer" },
                                _react2.default.createElement(_SpinButton2.default, {
                                    classNames: "btn btn-sm btn-styl font-weight-bold w-100" + " f16-default" + " pt-2 pb-2 " + buttonClass,
                                    buttonText: _ScheduleScreenStore2.default.getStartOrder() || _CartStore2.default.getCartCount() !== 0 ? "Update" : "Start Order",
                                    spinText: "Applying.. ",
                                    showSpinner: false,
                                    whenClicked: this.validateOrder,
                                    showIcon: false
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ScheduleScreenModal;
}(_react2.default.Component);

var PaneContent = function PaneContent(_ref) {
    var isActive = _ref.isActive,
        children = _ref.children;


    return _react2.default.createElement(
        "div",
        { className: "panel-default panel-border-less" },
        _react2.default.createElement(
            "div",
            { className: "panel-body", style: { padding: 0 } },
            children
        ),
        _react2.default.createElement("span", { className: "col-12 cart_border d-inline-block mb-3" })
    );
};

exports.default = ScheduleScreenModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/ScheduleOrderModal.jsx
// module id = 490
// module chunks = 0